import { LandingPageState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
    landingProfiles: (state: LandingPageState) => state.profiles,
    landingLanguages: (state: LandingPageState) => state.languages,
    landingCurrencies: (state: LandingPageState) => state.currencies,
    landingCountries: (state: LandingPageState) => state.countries,
    landingCities: (state: LandingPageState) => state.cities,
    landingStates: (state: LandingPageState) => state.states,
    accountCreationResult: (state: LandingPageState) => state.account_creation_result,
};

const { read } = getStoreAccessors<LandingPageState, State>('');


export const readLandingProfiles = read(getters.landingProfiles);
export const readLandingLanguages = read(getters.landingLanguages);
export const readLandingCurrencies = read(getters.landingCurrencies);
export const readLandingCities = read(getters.landingCities);
export const readLandingStates = read(getters.landingStates);
export const readLandingCountries = read(getters.landingCountries);
export const readAccountCreationResult = read(getters.accountCreationResult);
